import { render, staticRenderFns } from "./UrutanMenu.vue?vue&type=template&id=356ad5c6&"
import script from "./UrutanMenu.vue?vue&type=script&lang=js&"
export * from "./UrutanMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports